import React, { useEffect, useState } from 'react';
import Store from '../../store/Store';
import { Button } from './Button';
import { TrashIcon } from '../Icons';

interface UploadAssetProps {
	upload: {
		fileName: string;
		total: number;
		_update?: (progress: number | null) => void;
	};
	orderId: string;
}

export const UploadAsset: React.FC<UploadAssetProps> = props => {
	const upload = props.upload;
	const [progress, setProgress] = useState<number | null>(null);

	useEffect(() => {
		upload._update = setProgress;
		return () => {
			delete upload._update;
		};
	}, [upload]);

	return (
		<div className="flex min-h-[60px] font-semibold items-center justify-between rounded-2xl border border-[#d6e6f4] bg-[#EDF4FA] px-5 py-2 mt-5">
			   <span className="truncate max-w-[350px] block" title={upload.fileName}>
				   {upload.fileName}
			   </span>

			{progress === null ? (
				   <button
					   onClick={() => Store.removeUpload(props.orderId, upload.fileName)}
					   className="justify-items-center bg-white border border-[#E1320F] text-[#E1320F] hover:bg-[#FCEBE7] hover:text-white w-[34px] h-[34px] min-w-[34px] min-h-[34px] rounded-full p-0"
				   >
					   <TrashIcon />
				   </button>
			) : (
				<div className="upload-progress">
					<div className="upload-progress-label">
						<span>{'total: ' + formatFileSize(upload.total)}</span>
						<span>{(progress * 100).toFixed(1) + ' %'}</span>
					</div>
					<div className="upload-progress-bar">
						<span
							className="upload-progress-value"
							style={{ width: progress * 100 + '%' }}
						/>
					</div>
				</div>
			)}
		</div>
	);
};

const formatFileSize = (size: number): string => {
	const mb = 1024 * 1024;
	if (size >= mb) return (size / mb).toFixed(2) + ' MB';
	return (size / 1024).toFixed(2) + ' KB';
};
